const WHATSAPP_URL =
  "https://wa.me/256754909670?text=Hello%20Kasai%20Equipment%2C%20I%20need%20assistance.";

export function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Kasai Equipment on WhatsApp"
      className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_35px_-14px_rgba(37,211,102,0.85)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_45px_-18px_rgba(37,211,102,0.9)] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 32 32"
        className="h-7 w-7"
        fill="currentColor"
      >
        <path d="M16.01 3.2c-7.07 0-12.82 5.75-12.82 12.82 0 2.26.59 4.46 1.72 6.4l-1.83 6.68 6.84-1.79a12.78 12.78 0 0 0 6.09 1.55h.01c7.07 0 12.82-5.75 12.82-12.82S23.09 3.2 16.01 3.2Zm0 23.49h-.01c-1.92 0-3.8-.52-5.44-1.51l-.39-.23-4.06 1.06 1.08-3.96-.25-.41a10.6 10.6 0 0 1-1.62-5.62c0-5.89 4.79-10.68 10.69-10.68 2.85 0 5.53 1.11 7.55 3.13a10.62 10.62 0 0 1 3.13 7.56c0 5.88-4.79 10.66-10.68 10.66Zm5.86-7.98c-.32-.16-1.9-.94-2.19-1.05-.29-.11-.5-.16-.71.16-.21.32-.82 1.05-1 1.26-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.58-1.59-.95-.85-1.6-1.9-1.79-2.22-.19-.32-.02-.5.14-.66.15-.15.32-.37.48-.55.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.25 3.43 5.44 4.81.76.33 1.35.52 1.82.67.76.24 1.46.21 2.01.13.61-.09 1.9-.78 2.17-1.53.27-.75.27-1.4.19-1.53-.08-.13-.29-.21-.61-.37Z" />
      </svg>
    </a>
  );
}
